/**
 * "How would this plan print?" — answered without loading a font.
 *
 * Page counts depend only on geometry and on whether the header carries a date
 * or venue, so the export dialog can show what each chair style costs in paper
 * the moment it opens. Port of `export_status` in `api/v1/exports.py`.
 */

import type { ExportStatus, Plan, SeatLabelMode } from '../types'
import { chooseFloorPages } from './layout'
import { renderPlanFromPlan } from './model'

const MODES: SeatLabelMode[] = ['name', 'initials', 'none']

export function exportStatusFor(plan: Plan, seatLabels?: SeatLabelMode | null): ExportStatus {
  const pagesFor = (mode: SeatLabelMode) => chooseFloorPages(renderPlanFromPlan(plan, { seatLabels: mode }))
  const seated = plan.tables.reduce(
    (sum, table) => sum + table.seats.filter((seat) => seat.guestId).length,
    0,
  )
  return {
    exportable: plan.tables.length > 0,
    tables: plan.tables.length,
    seatedGuests: seated,
    seatLabels: plan.settings.seatLabels,
    floorPlanPages: pagesFor(seatLabels ?? plan.settings.seatLabels),
    floorPlanPagesBySeatLabels: {
      name: pagesFor('name'),
      initials: pagesFor('initials'),
      none: pagesFor('none'),
    },
  }
}

export { MODES as SEAT_LABEL_MODES }
